import { TicketPriority } from "interfaces/entities/ticket";

export const TICKET_PRIORITY_LABEL_MAP: Record<TicketPriority, string> = {
  [TicketPriority.Low]: "Low",
  [TicketPriority.Medium]: "Medium",
  [TicketPriority.High]: "High",
  [TicketPriority.Urgent]: "Urgent",
};
